/** @format */

import React, { useState, useEffect } from 'react';

import { Spin, Layout, Row, Col } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { GetLocalStorageValue } from '../../_config/utils/get-local-storage-value.util';
import { LOCAL_STORAGE } from '../../v2-config/constants/local-storage.constant';

import PageError from '../../components/Errors/PageError';

import UserInfo from './components/UserInfo';
import ChangePass from './components/ChangePass';

import serviceFindUser from '../../hooks/services/serviceFindUser';

import './style.css';

export default function Profile() {
	const email = GetLocalStorageValue(LOCAL_STORAGE.USER).email || null;
	const { token } = GetLocalStorageValue(LOCAL_STORAGE.USER);
	console.log('token', token);
	const [loading, setLoading] = useState(true);
	const [infoProfile, setInfoProfile] = useState(null);

	useEffect(() => {
		let mounted = true;
		(async () => {
			if (/^\w+([.-]?\w+)*@\w+([g.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
				let response = await serviceFindUser(token);
				console.log(response)
				if (!mounted) return;
				setInfoProfile(response);
				setLoading(false);
			} else {
				setInfoProfile({ error: true, statusCode: 500, message: 'Email invalido' });
			}
		})();
		return () => (mounted = false);
	}, [email, token]);

	if (loading) {
		return (
			<div className="ph-perfil-loading">
				<Spin />
			</div>
		);
	} else if (infoProfile?.error) {
		return <PageError detailError={infoProfile} />;
	}
	return (
		<>
			<Layout>
				<Layout.Content>
					<Layout.Header className="ph-perfil-title-main-container">
						<UserOutlined className="ph-perfil-title-main-icon" />
						<h3 className="ph-perfil-title-main-title">Perfil de Usuario</h3>
					</Layout.Header>
				</Layout.Content>
			</Layout>
			<Layout className="ph-perfil-main-container">
				<Layout.Content>
					<Row>
						<Col span={24}>
							<UserInfo infoProfile={infoProfile} />
						</Col>
						<Col span={24}>
							<Row>
								<Col className="ph-perfil-password-container" xs={24} sm={24} md={8} lg={8} xl={8}>
									<ChangePass email={email} token={token} />
								</Col>
							</Row>
						</Col>
					</Row>
				</Layout.Content>
			</Layout>
		</>
	);
}
